    <header class="page-head">
      <div>
        <h1 class="page-title">Contact</h1>
        <p class="page-subtitle">Reach the team for onboarding, integration, and customer support enquiries.</p>
      </div>
    </header>

    <section class="detail-grid">
      <article class="detail-card span-4">
        <h2 class="section-title">Email</h2>
        <p class="label">support&#64;centralprofile.co.za</p>
      </article>
      <article class="detail-card span-4">
        <h2 class="section-title">Phone</h2>
        <p class="label">+27 10 555 0148</p>
      </article>
      <article class="detail-card span-4">
        <h2 class="section-title">Office hours</h2>
        <p class="label">Mon to Fri, 08:00 to 17:00 SAST</p>
      </article>
    </section>
